import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SliderGallery from '../slider/SliderGallery.vue';
    import ModalTemplate from '../layouts/ModalTemplate.vue';
    import { galleryStore } from '@/store/modules/Gallery';

export default /*@__PURE__*/_defineComponent({
  __name: 'SliderFullScreen',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTemplate, {
    darkOverlay: true,
    closeBtn: true,
    scrollBodyLock: true,
    mode: "gallery",
    onClose: _unref(galleryStore).RESET_DATA
  }, {
    default: _withCtx(() => [
      _createVNode(SliderGallery, _normalizeProps(_guardReactiveProps({
                images: _unref(galleryStore).IMAGES,
                defaultActiveIndex: _unref(galleryStore).ACTIVE_INDEX,
                mode: 'full',
            })), null, 16)
    ]),
    _: 1
  }, 8, ["onClose"]))
}
}

})